import { Box, Button } from '@theme-ui/components'
import { useFormikContext } from 'formik'
import React, { useState } from 'react'
import { match } from 'ts-pattern'
import { ReportAction } from '../../../@types/report-action'
import { Modal } from '../../../components'
import Dropdown, {
  DropdownButton,
  DropdownList,
  DropdownMenu,
} from '../../../components/Dropdown/Dropdown'
import { ReportFormValues } from './ReportForm'

export default function InvestigatorActions({
  onConfirm,
}: {
  onConfirm(action: ReportAction, payload?: any): Promise<any>
}) {
  const [action, setAction] = useState<ReportAction>('NONE')
  const [loading, setLoading] = useState(false)
  const { values } = useFormikContext<ReportFormValues>()
  const remarks = values.finalNotes

  function handleConfirm(payload = {}) {
    setLoading(true)
    onConfirm(action, payload)
      .then(() => {
        setLoading(false)
        setAction('NONE')
      })
      .catch(() => setLoading(false))
  }

  return (
    <>
      <Dropdown placement="top-end">
        <DropdownButton>Tindakan</DropdownButton>
        <DropdownList>
          <DropdownMenu onClick={() => setAction('VERDICT_VIOLATION')}>
            Diteruskan Untuk Proses Sanksi
          </DropdownMenu>
          <DropdownMenu onClick={() => setAction('ARCHIVE')}>
            Diarsipkan
          </DropdownMenu>
        </DropdownList>
      </Dropdown>
      <Modal
        isOpen={action !== 'NONE'}
        onRequestClose={() => setAction('NONE')}
        header={`Anda yakin untuk ${match(action)
          .with('VERDICT_VIOLATION', () => 'diteruskan ke proses sanksi?')
          .with('ARCHIVE', () => 'arsipkan?')
          .otherwise(() => '')}`}
      >
        <Box sx={{ textAlign: 'right' }}>
          <Button
            disabled={loading}
            variant="secondary"
            sx={{ px: 4 }}
            onClick={() => setAction('NONE')}
          >
            Tidak
          </Button>
          <Button
            disabled={loading}
            sx={{ ml: '2', px: 4 }}
            onClick={() => handleConfirm({ remarks })}
          >
            Ya
          </Button>
        </Box>
      </Modal>
    </>
  )
}
